import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";

import { utComponent } from "./ut.component";

import { NavigationBarComponent } from "../shell-components/navigation-bar.component";
import { SidebarLeftComponent } from "../shell-components/sidebar-left.component";
import { SidebarRightComponent } from "../shell-components/sidebar-right.component";
import { PageContainerComponent } from "../shell-components/page-container.component";
import { FooterComponent } from "../shell-components/footer.component";

import { AppContainerComponent } from "../formcontainer/formcontainer.component";

import { ComponentModule } from "../../components/component.module";

import { utRoutingModule } from "./ut.routing";
import { MenusService } from "../forms/utmenus/utmenus.service";

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,

    ComponentModule,

    // Forms
    utRoutingModule,

  ],
  declarations: [
    utComponent,
    AppContainerComponent,
    NavigationBarComponent,
    SidebarLeftComponent,
    SidebarRightComponent,
    PageContainerComponent,

    FooterComponent
  ],
  providers: [MenusService]
})
export class utModule { }



// WEBPACK FOOTER //
// ./src/app/shell/ut/ut.module.ts